import React, { useState, useEffect } from 'react'
import SettingsForm from './form'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { sendErrorNotification, sendSuccessNotification } from '../../../../universal/notifications/notifications'
import { requestUpdateCompanyDetails, resetUpdateCompanyDetails, retrieveCompanyDetails } from '../../../../../redux/actions/company'
import { updateActiveCompanyName } from '../../../../../redux/actions/active-company'
import { UpperRow } from '../../../../library/upper-row'
import { SolidButton } from '../../../../library/button'
import { TableLoader } from '../../../../library/table-loader'

const Index = () => {

    const dispatch = useDispatch()

    const loading = useSelector(state => state.company.fetchDetails.loading)
    const details = useSelector(state => state.company.details)

    const saveLoading = useSelector(state => state.company.updateDetails.loading)

    const updateError = useSelector(state => state.company.updateDetails.error)
    const updateStatus = useSelector(state => state.company.updateDetails.status)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const companyDetailsLoading = useSelector(state => state.company.fetchDetails.loading)

    const [companyDetails, setCompanyDetails] = useState({
        avatar: null,
        email: null,
        address: null,
        country: null,
        city: null,
        postalCode: null,
        name: null,
        industry: null, 
    })


    useEffect(() => {
        if(!loading && details && details.name){
            setCompanyDetails({
                city: details.city,
                postalCode: details.postalCode,
                street: details.street,
                industry: details.industry,
                email: details.email,
                name: details.name,
                country: details.country
            })
        }
    }, [loading, details])

    useEffect(() => {
        if(updateError){
            sendErrorNotification("Kunne ikke oppdatere bedriftsinformasjon.")
            dispatch(resetUpdateCompanyDetails())
        }
    }, [updateError])

    useEffect(() => {
        if(updateStatus){
            sendSuccessNotification("Bedriftsinformasjonen ble oppdatert.")
            dispatch(resetUpdateCompanyDetails())
            dispatch(retrieveCompanyDetails({companyId: selectedCompany}))
        }
    }, [updateStatus])

    const clickSave = () => {
        if(companyDetails && companyDetails.name && companyDetails.email){
            dispatch(requestUpdateCompanyDetails({companyId: selectedCompany, details: companyDetails}))
        } else {
            sendErrorNotification("Fyll inn navn og e-post på bedriften din.")
        }
    }

    const renderMainButtons = () => {
        if(!companyDetailsLoading && !loading){
            return [
                <SolidButton onClick={() => clickSave()} color="blue" size="regular" icon={saveLoading ? <i className="fas fa-circle-notch fa-spin"/>:null} title={loading ? "Lagrer..":"Lagre endringer"}/>
            ]
        }
        return null
    }

    return(
        <div className="dashboard-company-payments-container">
            <div className="inner-dashboard-company-payments-container">
                <UpperRow title="Innstillinger" buttons={renderMainButtons()}/>
                {companyDetailsLoading ? <TableLoader/>:<SettingsForm companyDetails={companyDetails} setCompanyDetails={setCompanyDetails}/>}
                <ToastContainer/>
            </div>
        </div>
    )
}

export default Index